import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import SearchMRecordDetailListContainer from '../containers/SearchMRecordDetailListContainer.jsx';

export default class MaintenanceSearchRecordComponent extends React.Component {

	componentDidMount() {
	}

	componentWillUnmount() {
	}

	thumbnails(photos) {
        let ret = [];
        if (photos) {
            return photos;
        }
        return ret;
    }

	render() {
		let cardTr = null;
		if (this.props.card) {
			cardTr = (
				<tr>
					<td>{this.props.card.get('order_id')}</td>
					<td>{this.props.card.get('note')}</td>
					<td>{this.props.card.get('order_date')}</td>
					<td>{this.props.card.get('code')}</td>
					<td>{this.props.card.get('customer_name')}</td>
					<td>{this.props.card.get('organization')}-{this.props.card.get('unit')}</td>
					<td>{this.props.card.get('owner')}</td>
					<td>{this.props.card.get('discard')}</td>
					<td>{this.props.card.get('create_time')}</td>
				</tr>
			);
		}

		return (
			<div>
				<h4>維修卡</h4>
				<Table bordered condensed hover striped>
					<thead>
						<tr>
							<th style={{ verticalAlign: 'middle' }}>訂單編號</th>
							<th style={{ verticalAlign: 'middle' }}>註記</th>
							<th style={{ verticalAlign: 'middle' }}>訂單時間</th>
							<th style={{ verticalAlign: 'middle' }}>序號</th>
							<th style={{ verticalAlign: 'middle' }}>客戶名稱</th>
							<th style={{ verticalAlign: 'middle' }}>單位</th>
							<th style={{ verticalAlign: 'middle' }}>姓名</th>
							<th style={{ verticalAlign: 'middle' }}>不再使用</th>
							<th style={{ verticalAlign: 'middle' }}>維修時間</th>
						</tr>
					</thead>
					<tbody>
						{cardTr}
					</tbody>
				</Table>
				<h4>清洗維修紀錄明細</h4>
				<SearchMRecordDetailListContainer />
				<br />
				<h4>照片 - 清洗維修前</h4>
				<Row>
					{
						this.thumbnails(this.props.prePhotos).map(
							(item, index) =>
								<Col xs={12} sm={6} key={item.get('id')}>
									<a href={item.get('image')} target="_blank">
										<img src={item.get('image')} className="img-thumbnail" alt="" />
									</a>
								</Col>
						)
					}
				</Row>
				<h4>照片 - 清洗維修後</h4>
				<Row>
					{
						this.thumbnails(this.props.postPhotos).map(
							(item, index) =>
								<Col xs={12} sm={6} key={item.get('id')}>
									<a href={item.get('image')} target="_blank">
										<img src={item.get('image')} className="img-thumbnail" alt="" />
									</a>
								</Col>
						)
					}
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceSearchRecordComponent.jsx